<template>
  <div
    class="flex flex-col px-10 md:px-0 pt-24 md:pl-140px lg:pl-200px min-h-screen"
  >
    <div class="text-30px md:text-70px text-qwray font-Foco md:mt-24 font-bold">
      {{ $t('impressum.title') }}
    </div>
    <div class="md:flex md:flex-row" style="width: 100%;">
      <div class="p-2" style="padding-right: 50px;">
        <p class="whitespace-pre-line">{{ $t('impressum.body.left') }}</p>
      </div>

      <div class="p-2">
        <div>
          <span class="title">{{ $t('impressum.right_top.header') }}</span
          ><br />
          <p class="whitespace-pre-line">
            {{ $t('impressum.right_top.content') }}
          </p>
        </div>

        <div class="mt-5">
          <span class="title">{{ $t('impressum.right_bottom.header') }}</span
          ><br />
          <p class="whitespace-pre-line">
            {{ $t('impressum.right_bottom.content') }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
};
</script>

<style scoped>
h1 {
  color: #2b4047;
}

.title {
  font-family: 'Foco', sans-serif;
  font-weight: 700;
  line-height: 25px;
  color: #2b4047;
}

#impressum {
  text-align: left;
  font-size: 12px;
  vertical-align: middle;
  letter-spacing: 1px;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: auto;
  padding: 5% 0%;
}

#impressum-title {
  margin: auto;
  width: 100%;
  clear: both;
  margin-bottom: 5%;
}

#left {
  width: 50%;
  float: left;
  text-align: left;
}

#right {
  width: 50%;
  float: right;
  text-align: left;
}

.container {
  width: 80%;
  padding-right: 10%;
  padding-left: 10%;
  margin-right: auto;
  margin-left: auto;
}

p {
  font-family: Lato, sans-serif;
  font-weight: 400;
  color: #2b4047;
}

.title {
  font-family: 'Foco', sans-serif;
  font-weight: 700;
  line-height: 25px;
}

h4 {
  color: #2b4047;
  text-align: center;
  padding: 3% 5%;
  line-height: 30px;
  font-family: 'Foco', sans-serif;
}
</style>
